import { ArrowLeftSolid, ArrowRightSolid } from '@allocab/allocab-icons';
import { twJoin } from 'tailwind-merge';

type Props = {
  label: string;
  onPrevious: () => void;
  onNext: () => void;
  onHeaderClick?: () => void;
};

export const Controls = ({ label, onPrevious, onNext, onHeaderClick }: Props) => {
  return (
    <div className="flex justify-between mb-2">
      <button
        type="button"
        className="bg-white dark:bg-gray-700 rounded-lg text-gray-500 dark:text-white hover:bg-gray-100 dark:hover:bg-gray-600 hover:text-gray-900 dark:hover:text-white text-lg p-2.5 focus:outline-none focus:ring-2 focus:ring-gray-200 prev-btn"
        onClick={onPrevious}
      >
        <ArrowLeftSolid width={16} height={16} className="fill-current" />
      </button>
      <button
        type="button"
        className={twJoin(
          'text-sm rounded-lg text-gray-900 dark:text-white bg-white dark:bg-gray-700 font-semibold py-2.5 px-5 focus:outline-none focus:ring-2 focus:ring-gray-200 view-switch capitalize',
          !!onHeaderClick && 'hover:bg-gray-100 dark:hover:bg-gray-600',
        )}
        onClick={onHeaderClick}
        disabled={!onHeaderClick}
      >
        {label}
      </button>
      <button
        type="button"
        className="bg-white dark:bg-gray-700 rounded-lg text-gray-500 dark:text-white hover:bg-gray-100 dark:hover:bg-gray-600 hover:text-gray-900 dark:hover:text-white text-lg p-2.5 focus:outline-none focus:ring-2 focus:ring-gray-200 next-btn"
        onClick={onNext}
      >
        <ArrowRightSolid width={16} height={16} className="fill-current" />
      </button>
    </div>
  );
};
